import { render, staticRenderFns } from "./QuantitiesReservation.template.vue?vue&type=template&id=0115e528&scoped=true&"
var script = {}
import style0 from "./QuantitiesReservation.template.vue?vue&type=style&index=0&id=0115e528&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0115e528",
  null
  
)

export default component.exports